import React, { useState } from "react";
import axios from "axios";


const usePermission = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
}) => {
    let mainAPI = '/dynamicWebsite/frontend/permission'
    const [source, setSource] = useState(axios.CancelToken.source())
    const [data, setData] = useState([])
    const getPermissionData = ({
        classify_structure_id,
        classify_structure_type_id,
        custom_filter_key,
        custom_filter_value
    }) => {
        source.cancel('')
        onBefore({
            axiosMode: "get"
        })
        const source_ = axios.CancelToken.source()
        setSource(source_)
        return axios.get(mainAPI, {
            params: {
                classify_structure_id,
                classify_structure_type_id,
                custom_filter_key,
                custom_filter_value
            },
            cancelToken: source_.token,

        })
            .then((response) => {
                let data = response.data?.data || []
                setData(data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return data
            })
            .catch((error) => {
                if (!axios.isCancel(error)) {
                }
            })

    }
    const [permissionChildrenData,setPermissionChildrenData] = useState([])

    const getPermissionChildrenData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get(`/dynamicWebsite/frontend/permission_children`, {
            params: params,

        })
            .then((response) => {
                let data = response.data?.data || []
                setPermissionChildrenData(data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return data
            })
            .catch((error) => {
                if (!axios.isCancel(error)) {
                }
            })

    }

    const [permissionMainPageData,setPermissionMainPageData] = useState([])
    const getPermissionMainPageData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get(`/dynamicWebsite/frontend/permission_mainpage`, {
            params: params,

        })
            .then((response) => {
                let data = response.data?.data || []
                setPermissionMainPageData(data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return data
            })
            .catch((error) => {
                if (!axios.isCancel(error)) {
                }
            })

    }
    // const postPermissionData = (data) => {
    //     onBefore({
    //         axiosMode: "post"
    //     })
    //     axios.post('/system/news/type',
    //         data
    //     )
    //         .then((response) => {
    //             let responseData = response.data
    //             let status = responseData?.status
    //             if (status === "fail") {
    //                 onFinish(
    //                     {
    //                         axiosMode: "post",
    //                         status: "error"
    //                     }
    //                 )
    //             }
    //             else {
    //                 onFinish(
    //                     {
    //                         axiosMode: "post",
    //                         status: "success"
    //                     }
    //                 )
    //             }
    //         })
    //         .catch(() => {
    //             onFinish(
    //                 {
    //                     axiosMode: "post",
    //                     status: "error"
    //                 }
    //             )
    //         })

    // }
    // const patchPermissionData = (data) => {

    //     onBefore({
    //         axiosMode: "patch"
    //     })
    //     axios.patch('/system/news/type',

    //             data

    //     )
    //         .then((response) => {
    //             let responseData = response.data
    //             let status = responseData?.status
    //             if (status === "fail") {
    //                 onFinish(
    //                     {
    //                         axiosMode: "patch",
    //                         status: "error"
    //                     }
    //                 )
    //             }
    //             else {
    //                 onFinish(
    //                     {
    //                         axiosMode: "patch",
    //                         status: "success"
    //                     }
    //                 )
    //             }
    //         })
    //         .catch(() => {
    //             onFinish(
    //                 {
    //                     axiosMode: "patch",
    //                     status: "error"
    //                 }
    //             )
    //         })
    // }
    // const deletePermissionData = (data) => {
    //     onBefore({
    //         axiosMode: "delete"
    //     })
    //     axios.delete('/system/news/type',
    //         {
    //             data
    //         }
    //     )
    //         .then((response) => {
    //             let responseData = response.data
    //             let status = responseData?.status
    //             if (status === "fail") {
    //                 onFinish(
    //                     {
    //                         axiosMode: "delete",
    //                         status: "error"
    //                     }
    //                 )
    //             }
    //             else {
    //                 onFinish(
    //                     {
    //                         axiosMode: "delete",
    //                         status: "success"
    //                     }
    //                 )
    //             }
    //         })
    //         .catch(() => {
    //             onFinish(
    //                 {
    //                     axiosMode: "delete",
    //                     status: "error"
    //                 }
    //             )
    //         })
    // }
    return {
        permissionData: data,
        permissionChildrenData:permissionChildrenData,
        permissionMainPageData:permissionMainPageData,
        getPermissionData,
        getPermissionChildrenData,
        getPermissionMainPageData,
        // postPermissionData,
        // patchPermissionData,
        // deletePermissionData,
    }
}
export { usePermission }
